import { createReducer, on } from '@ngrx/store';
import * as MergeActions from './merge.actions';
import { initialState } from './merge.state';

export const mergeReducer = createReducer(
  initialState,
  
  on(MergeActions.showCollisions, (state, { data }) => ({
    ...state,
    id: data[0],
    canMerge: data[1],
    result: null,
    isBusy: true,
  })),
  
  on(MergeActions.showCollisionsSuccess, (state, { result }) => ({
    ...state,
    result: result,
    isBusy: false,
  })),
  
  on(MergeActions.showCollisionsError, (state) => ({
    ...state,
    result: null,
    isBusy: false,
  })),
  
  on(MergeActions.merge, (state, { additionalId }) => ({
    ...state,
    additionalId: additionalId,
    isBusy: true,
  })),
  
  on(MergeActions.mergeSuccess, (state) => ({
    ...state,
    isBusy: false,
  })),
  
  on(MergeActions.mergeFailed, (state) => ({
    ...state,
    isBusy: false,
  }))
);
